"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var definitions_1 = require("./definitions");
var filter_1 = require("./filter");
/**
 * =============================================================================
 * Entity Filter represents an entire entity to use for search purposes
 * =============================================================================
 */
var EntityFilter = /** @class */function (_super) {
  __extends(EntityFilter, _super);
  function EntityFilter() {
    return _super.call(this) || this;
  }
  /**
   * Change the schema for which to look this entity up in
   * @param  schema String
   * @return    void
   */
  EntityFilter.prototype.setSchema = function (schema, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.schema = schema;
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  /**
   * Get the schema for which to look this entity up in
   * @return string
   */
  EntityFilter.prototype.getSchema = function () {
    return this.schema;
  };
  /**
   * Change the type of the entity to look up
   * @param  type String
   */
  EntityFilter.prototype.setType = function (type, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.type = type;
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  /**
   * Get the type of the entity to look up
   * @return string
   */
  EntityFilter.prototype.getType = function () {
    return this.type;
  };
  /**
   * Change the space of the entity to look up
   * @param  space String
   */
  EntityFilter.prototype.setSpace = function (space, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.space = space;
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  /**
   * Get the space of the entity to look up
   * @return string
   */
  EntityFilter.prototype.getSpace = function () {
    return this.space;
  };
  /**
   * Change the uri of the entity to look up
   * @param  uri String
   */
  EntityFilter.prototype.setUri = function (uri, silent) {
    if (silent === void 0) {
      silent = false;
    }
    this.uri = uri;
    if (!silent) {
      this.updated.next(this);
    }
    return this;
  };
  /**
   * Get the uri of the entity to look up
   * @return string
   */
  EntityFilter.prototype.getUri = function () {
    return this.uri;
  };
  /**
   * Convert this filter object to a plain JSON object in IqlLeafQuery format
   * @return JSON<IqlLeafQuery>
   */
  EntityFilter.prototype.toJson = function (clean) {
    if (clean === void 0) {
      clean = false;
    }
    // check if these values are valid. range is different, there always is a range by nature
    var ret = __assign({}, _super.prototype.toJson.call(this), {
      schema: this.getSchema(),
      type: this.getType(),
      space: this.getSpace(),
      uri: this.getUri()
    });
    Object.keys(ret).forEach(function (key) {
      if (ret[key] === null || ret[key] === undefined || !ret[key]) {
        delete ret[key];
      } else if (Array.isArray(ret[key]) && ret[key].length === 0) {
        delete ret[key];
      }
    });
    // if clean and nothing defined, return undefined instead of an object
    if (clean && !Object.keys(ret).length) {
      return undefined;
    }
    return ret;
  };
  /**
   * toJson convert this filter object to a plain JSON object
   * @return    Object JSON representation of this filter
   */
  EntityFilter.prototype.toQueryString = function () {
    var sort = _super.prototype.toQueryString.call(this);
    // we don't need to transport the fakeID, only manual ones
    var id = this.getIdentifier() || '';
    var schema = this.getSchema();
    var space = this.getSpace();
    var type = this.getType();
    var uri = this.getUri();
    var filterControls = "uri" + definitions_1.filterControl + id + definitions_1.filterControl + sort;
    var qs = "" + filterControls + definitions_1.leafBegin + definitions_1.quoteMark + schema + definitions_1.quoteMark + definitions_1.valueSeparator + definitions_1.quoteMark + type + definitions_1.quoteMark + definitions_1.valueSeparator + definitions_1.quoteMark + space + definitions_1.quoteMark + definitions_1.valueSeparator + definitions_1.quoteMark + uri + definitions_1.quoteMark + definitions_1.leafEnd;
    return "" + (this.exclude ? definitions_1.filterNegate : '') + qs;
  };
  /**
   * Convert this filter object to a Human readable format
   * @return     string
   */
  EntityFilter.prototype.toHumanReadable = function () {
    // we don't need to transport the fakeID, only manual ones
    var id = this.getIdentifier() ? " " + definitions_1.HRfilterID + " " + this.getIdentifier() : '';
    return (this.getExclude() ? definitions_1.HRfilterNegate : '') + " ENTITY " + this.getSchema() + " " + this.getType() + " " + this.getSpace() + " " + this.getUri() + " " + _super.prototype.toHumanReadable.call(this) + id;
  };
  /**
   * Clones the Current LeafFilter
   * @return LeafFilter
   */
  EntityFilter.prototype.clone = function () {
    var clone = new EntityFilter().setSchema(this.getSchema()).setType(this.getType()).setSpace(this.getSpace()).setUri(this.getUri()).setExclude(this.getExclude()).setSort(this.getSort()).setIdentifier(this.getIdentifier());
    return clone;
  };
  EntityFilter.prototype.equals = function (other, ignoreSort) {
    if (ignoreSort === void 0) {
      ignoreSort = false;
    }
    // Make sure the other is a EntityFilter as well
    if (!other.schema) {
      return false;
    }
    // Check all the basics
    if (!_super.prototype.equals.call(this, other, ignoreSort)) {
      return false;
    }
    // Check all the values
    return this.getSchema() === other.getSchema() && this.getType() === other.getType() && this.getSpace() === other.getSpace() && this.getUri() === other.getUri();
  };
  return EntityFilter;
}(filter_1.Filter);
exports.EntityFilter = EntityFilter;